export const enum ServerEventCodes {
  CurrentNotifications = 'CURRENT_NOTIFICATIONS',
  NewNotifications = 'NEW_NOTIFICATIONS',
  ChangedNotifications = 'CHANGED_NOTIFICATIONS',
}
